/** DvState
 * generated by enums.tst
**/
var DvState;
(function (DvState) {
    DvState[DvState["Unknown"] = 0] = "Unknown";
    DvState[DvState["Uploaded"] = 1] = "Uploaded";
    DvState[DvState["Submitted"] = 2] = "Submitted";
    DvState[DvState["Processing"] = 3] = "Processing";
    DvState[DvState["Completed"] = 4] = "Completed";
    DvState[DvState["Incomplete"] = 5] = "Incomplete";
    DvState[DvState["Failure"] = 6] = "Failure";
})(DvState || (DvState = {}));
